"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agent = void 0;
var axios_1 = __importDefault(require("axios"));
var Result_1 = require("../../models/concrete/Result");
var HTTPError_1 = require("../../models/concrete/HTTPError");
var Pagination_1 = require("../../models/common/Pagination");
var Agent = /** @class */ (function () {
    function Agent(baseUrl, headers, configProps) {
        this.transport = this.configureTransport(baseUrl, headers, configProps);
    }
    Agent.prototype.getConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_1, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get('/configs')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_1 = _a.sent();
                        response = ex_1.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getProductBySlug = function (slug, relatedChildren, sameProducts, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var query, expandParams, expandQuery, response, data, ex_2, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = '';
                        expandParams = [];
                        expandParams.push(relatedChildren ? 'relatedChildren' : '');
                        expandParams.push(sameProducts ? 'sameProducts' : '');
                        if (extensions && extensions.length) {
                            expandParams.push.apply(expandParams, extensions);
                        }
                        expandQuery = expandParams.filter(function (ep) { return !!ep; }).join(',');
                        if (expandQuery) {
                            query += "expand=".concat(expandQuery);
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/products/".concat(slug).concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_2 = _a.sent();
                        response = ex_2.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getProductsByCategory = function (categorySlug, filterSlugs, page, perPage, sort, filters, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, pagination, ex_3, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = (filterSlugs === null || filterSlugs === void 0 ? void 0 : filterSlugs.map(function (s) {
                            return "filter[slug][]=".concat(s);
                        })) || [];
                        if (page) {
                            queryParams.push("page=".concat(page));
                        }
                        if (perPage) {
                            queryParams.push("per-page=".concat(perPage));
                        }
                        if (sort) {
                            queryParams.push("sort=".concat(sort));
                        }
                        if (filters.length) {
                            queryParams = __spreadArray(__spreadArray([], queryParams, true), filters, true);
                        }
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/categories/".concat(categorySlug, "/products").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        pagination = new Pagination_1.Pagination(response.headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(response.headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_3 = _a.sent();
                        response = ex_3.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getRelatedProducts = function (slug, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, ex_4, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = [];
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/products/".concat(slug, "/related").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_4 = _a.sent();
                        response = ex_4.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getSameProducts = function (slug, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, ex_5, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = [];
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/products/".concat(slug, "/same").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_5 = _a.sent();
                        response = ex_5.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getRecentlyProducts = function (extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, ex_6, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = [];
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/recently-viewed".concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_6 = _a.sent();
                        response = ex_6.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getCategories = function (perPage) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_7, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/categories?per-page=".concat(perPage))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_7 = _a.sent();
                        response = ex_7.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getFiltersByCategorySlug = function (categorySlug, slugs, filters, expanded, canceledOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryArray, query, response, data, ex_8, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryArray = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        });
                        if (expanded) {
                            queryArray.push('options[prices][active]=1');
                            queryArray.push('options[categories][active]=1');
                            queryArray.push('options[categories][depth]=999');
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_active']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][active]=1'; }), 1);
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_depth']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][depth]=999'; }), 1);
                        }
                        query = queryArray.join('&');
                        if (query.length && filters.length) {
                            query += '&';
                        }
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/categories/".concat(categorySlug, "/filter-data").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_8 = _a.sent();
                        response = ex_8.response;
                        console.log(ex_8, response);
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getAvailableFilterVariantsByCategory = function (categorySlug, slugs, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_9, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        }).join('&');
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/categories/".concat(categorySlug, "/filter-ajax").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.values,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_9 = _a.sent();
                        response = ex_9.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentMenus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_10, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get('/cms/menus')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_10 = _a.sent();
                        response = ex_10.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentPage = function (pageSlug) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_11, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/page-by-path?path=".concat(pageSlug))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_11 = _a.sent();
                        response = ex_11.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentPageById = function (pageId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_12, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/page/".concat(pageId))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_12 = _a.sent();
                        response = ex_12.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getContentHomePage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_13, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/cms/home")];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_13 = _a.sent();
                        response = ex_13.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getCartItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_14, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get('/cart')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_14 = _a.sent();
                        response = ex_14.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.addItemToCart = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var reqBody, response, data, ex_15, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        reqBody = {
                            product_id: body.productId,
                            quantity: body.quantity,
                        };
                        if (body.modificationId) {
                            reqBody.modification_id = body.modificationId;
                        }
                        if (body.data) {
                            reqBody.data = body.data;
                        }
                        return [4 /*yield*/, this.transport.post('/cart', reqBody)];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_15 = _a.sent();
                        response = ex_15.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.removeItemFromCart = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_16, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.delete("/cart/".concat(id))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_16 = _a.sent();
                        response = ex_16.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.clearCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_17, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.delete("/cart")];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_17 = _a.sent();
                        response = ex_17.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.updateCartItem = function (id, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_18, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.put("/cart/".concat(id), __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_18 = _a.sent();
                        response = ex_18.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.signUp = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_19, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/signup", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_19 = _a.sent();
                        response = ex_19.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.requestPassword = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_20, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/request", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_20 = _a.sent();
                        response = ex_20.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.signIn = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_21, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.post("/users/login", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.token,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_21 = _a.sent();
                        response = ex_21.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getUser = function (expanded) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_22, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = '';
                        if (expanded) {
                            query = '?expand=group';
                        }
                        return [4 /*yield*/, this.transport.get("/users/me".concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_22 = _a.sent();
                        response = ex_22.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.updateUser = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_23, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.put("/users/me", __assign({}, body))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_23 = _a.sent();
                        response = ex_23.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getWishlistItems = function (extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, ex_24, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = [];
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/wishlist".concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_24 = _a.sent();
                        response = ex_24.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.addItemToWishlist = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var reqBody, response, data, ex_25, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        reqBody = {
                            id: body.id,
                        };
                        return [4 /*yield*/, this.transport.post('/wishlist', reqBody)];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_25 = _a.sent();
                        response = ex_25.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.clearWishlist = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_26, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.delete('/wishlist')];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_26 = _a.sent();
                        response = ex_26.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.removeItemFromWishlist = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, ex_27, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.delete("/wishlist/".concat(id))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_27 = _a.sent();
                        response = ex_27.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.setUserAvatar = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response, ex_28, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formData = new FormData();
                        formData.append('avatar', data);
                        return [4 /*yield*/, this.transport.post("/users/me/avatar", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        // const { data } = response;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_28 = _a.sent();
                        response = ex_28.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getPromotions = function (id, page) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, response, data, headers, pagination, ex_29, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = [
                            id ? "filter[id]=".concat(id) : undefined,
                            page ? "page=".concat(page) : undefined
                        ].filter(function (i) { return i != undefined; }).join('&');
                        url = ["/promotions", query || undefined].filter(function (i) { return i != undefined; }).join('?');
                        return [4 /*yield*/, this.transport.get(url)];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        pagination = new Pagination_1.Pagination(headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_29 = _a.sent();
                        response = ex_29.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getPromotionBySlug = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, headers, ex_30, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/promotions/".concat(slug))];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(headers)
                            })];
                    case 2:
                        ex_30 = _a.sent();
                        response = ex_30.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getProductsByPromotion = function (promotionSlug, filterSlugs, page, perPage, sort, filters, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, pagination, ex_31, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = (filterSlugs === null || filterSlugs === void 0 ? void 0 : filterSlugs.map(function (s) {
                            return "filter[slug][]=".concat(s);
                        })) || [];
                        if (page) {
                            queryParams.push("page=".concat(page));
                        }
                        if (perPage) {
                            queryParams.push("per-page=".concat(perPage));
                        }
                        if (sort) {
                            queryParams.push("sort=".concat(sort));
                        }
                        if (filters.length) {
                            queryParams = __spreadArray(__spreadArray([], queryParams, true), filters, true);
                        }
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/promotions/".concat(promotionSlug, "/products").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        pagination = new Pagination_1.Pagination(response.headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(response.headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_31 = _a.sent();
                        response = ex_31.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getFiltersByPromotionSlug = function (promotionSlug, slugs, filters, expanded, canceledOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryArray, query, response, data, ex_32, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryArray = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        });
                        if (expanded) {
                            queryArray.push('options[prices][active]=1');
                            queryArray.push('options[categories][active]=1');
                            queryArray.push('options[categories][depth]=999');
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_active']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][active]=1'; }), 1);
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_depth']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][depth]=999'; }), 1);
                        }
                        query = queryArray.join('&');
                        if (query.length && filters.length) {
                            query += '&';
                        }
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/promotions/".concat(promotionSlug, "/filter-data").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_32 = _a.sent();
                        response = ex_32.response;
                        console.log(ex_32, response);
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getAvailableFilterVariantsByPromotion = function (promotionSlug, slugs, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_33, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        }).join('&');
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/promotions/".concat(promotionSlug, "/filter-ajax").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.values,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_33 = _a.sent();
                        response = ex_33.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getBrands = function (id, page) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, response, data, headers, pagination, ex_34, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = [
                            id ? "filter[id]=".concat(id) : undefined,
                            page ? "page=".concat(page) : undefined
                        ].filter(function (i) { return i != undefined; }).join('&');
                        url = ["/brands", query || undefined].filter(function (i) { return i != undefined; }).join('?');
                        return [4 /*yield*/, this.transport.get(url)];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        pagination = new Pagination_1.Pagination(headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_34 = _a.sent();
                        response = ex_34.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getBrandBySlug = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, headers, ex_35, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/brands/".concat(slug))];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(headers)
                            })];
                    case 2:
                        ex_35 = _a.sent();
                        response = ex_35.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getProductsByBrand = function (brandSlug, filterSlugs, page, perPage, sort, filters, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, pagination, ex_36, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = (filterSlugs === null || filterSlugs === void 0 ? void 0 : filterSlugs.map(function (s) {
                            return "filter[slug][]=".concat(s);
                        })) || [];
                        if (page) {
                            queryParams.push("page=".concat(page));
                        }
                        if (perPage) {
                            queryParams.push("per-page=".concat(perPage));
                        }
                        if (sort) {
                            queryParams.push("sort=".concat(sort));
                        }
                        if (filters.length) {
                            queryParams = __spreadArray(__spreadArray([], queryParams, true), filters, true);
                        }
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/brands/".concat(brandSlug, "/products").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        pagination = new Pagination_1.Pagination(response.headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(response.headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_36 = _a.sent();
                        response = ex_36.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getFiltersByBrandSlug = function (brandSlug, slugs, filters, expanded, canceledOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryArray, query, response, data, ex_37, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryArray = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        });
                        if (expanded) {
                            queryArray.push('options[prices][active]=1');
                            queryArray.push('options[categories][active]=1');
                            queryArray.push('options[categories][depth]=999');
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_active']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][active]=1'; }), 1);
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_depth']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][depth]=999'; }), 1);
                        }
                        query = queryArray.join('&');
                        if (query.length && filters.length) {
                            query += '&';
                        }
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/brands/".concat(brandSlug, "/filter-data").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_37 = _a.sent();
                        response = ex_37.response;
                        console.log(ex_37, response);
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getAvailableFilterVariantsByBrand = function (brandSlug, slugs, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_38, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        }).join('&');
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/brands/".concat(brandSlug, "/filter-ajax").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.values,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_38 = _a.sent();
                        response = ex_38.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getSets = function (id, page) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, response, data, headers, pagination, ex_39, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = [
                            id ? "filter[id]=".concat(id) : undefined,
                            page ? "page=".concat(page) : undefined
                        ].filter(function (i) { return i != undefined; }).join('&');
                        url = ["/filter-pages", query || undefined].filter(function (i) { return i != undefined; }).join('?');
                        return [4 /*yield*/, this.transport.get(url)];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        pagination = new Pagination_1.Pagination(headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_39 = _a.sent();
                        response = ex_39.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getSetBySlug = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, headers, ex_40, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.transport.get("/filter-pages/".concat(slug))];
                    case 1:
                        response = _a.sent();
                        data = response.data, headers = response.headers;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(headers)
                            })];
                    case 2:
                        ex_40 = _a.sent();
                        response = ex_40.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getProductsBySet = function (setSlug, filterSlugs, page, perPage, sort, filters, extensions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, formattedExtensions, query, response, data, pagination, ex_41, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = (filterSlugs === null || filterSlugs === void 0 ? void 0 : filterSlugs.map(function (s) {
                            return "filter[slug][]=".concat(s);
                        })) || [];
                        if (page) {
                            queryParams.push("page=".concat(page));
                        }
                        if (perPage) {
                            queryParams.push("per-page=".concat(perPage));
                        }
                        if (sort) {
                            queryParams.push("sort=".concat(sort));
                        }
                        if (filters.length) {
                            queryParams = __spreadArray(__spreadArray([], queryParams, true), filters, true);
                        }
                        if (extensions.length) {
                            formattedExtensions = extensions.join(',');
                            queryParams.push("expand=".concat(formattedExtensions));
                        }
                        query = queryParams.join('&');
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/filter-pages/".concat(setSlug, "/products").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        pagination = new Pagination_1.Pagination(response.headers);
                        return [2 /*return*/, Result_1.Result.ok({
                                data: {
                                    data: data,
                                    sessionToken: this.getSessionToken(response.headers)
                                },
                                pagination: pagination
                            })];
                    case 2:
                        ex_41 = _a.sent();
                        response = ex_41.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getFiltersBySetSlug = function (setSlug, slugs, filters, expanded, canceledOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var queryArray, query, response, data, ex_42, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryArray = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        });
                        if (expanded) {
                            queryArray.push('options[prices][active]=1');
                            queryArray.push('options[categories][active]=1');
                            queryArray.push('options[categories][depth]=999');
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_active']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][active]=1'; }), 1);
                        }
                        if (canceledOptions === null || canceledOptions === void 0 ? void 0 : canceledOptions['categories_depth']) {
                            queryArray.splice(queryArray.findIndex(function (t) { return t === 'options[categories][depth]=999'; }), 1);
                        }
                        query = queryArray.join('&');
                        if (query.length && filters.length) {
                            query += '&';
                        }
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/filter-pages/".concat(setSlug, "/filter-data").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_42 = _a.sent();
                        response = ex_42.response;
                        console.log(ex_42, response);
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getAvailableFilterVariantsBySet = function (setSlug, slugs, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, data, ex_43, response, httpError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        query = slugs.map(function (s) {
                            return "slugs[char][]=".concat(s);
                        }).join('&');
                        if (filters) {
                            query += filters.join('&');
                        }
                        if (query) {
                            query = '?' + query;
                        }
                        return [4 /*yield*/, this.transport.get("/filter-pages/".concat(setSlug, "/filter-ajax").concat(query))];
                    case 1:
                        response = _a.sent();
                        data = response.data;
                        return [2 /*return*/, Result_1.Result.ok({
                                data: data.values,
                                sessionToken: this.getSessionToken(response.headers)
                            })];
                    case 2:
                        ex_43 = _a.sent();
                        response = ex_43.response;
                        httpError = new HTTPError_1.HTTPError(response.config.url, response.config.method, response.status, {}, //JSON.parse(response.config.data),
                        response.config.headers);
                        return [2 /*return*/, Result_1.Result.fail(httpError)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.getSessionToken = function (headers) {
        return headers['x-session-token'] || '';
    };
    Agent.prototype.configureTransport = function (baseUrl, headers, configProps) {
        var axiosHeaders = __assign({}, headers || {});
        var axiosConfig = {};
        if (configProps === null || configProps === void 0 ? void 0 : configProps.cancelToken) {
            axiosConfig.cancelToken = configProps === null || configProps === void 0 ? void 0 : configProps.cancelToken;
        }
        console.log('axiosConfig: ', axiosConfig);
        var instance = axios_1.default.create(__assign({ baseURL: baseUrl, headers: axiosHeaders }, axiosConfig));
        return instance;
    };
    return Agent;
}());
exports.Agent = Agent;
//# sourceMappingURL=Agent.js.map